import { useNavigate } from "react-router-dom";

import ConfirmationQuestion from "../../../components/Questions/ConfirmationQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { questionContent } from "../questions";
import { shouldCheckDailyActivity } from "../DailyActivity/util";

const Financial: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (answer: ConfirmationAnswer) => {
    setAnswers({
      ...answers,
      financial: answer,
      ...(answer !== ConfirmationAnswer.Yes
        ? {
            financialDetail: undefined,
            psr: undefined,
          }
        : {}),
    });
  };

  const onContinue = () => {
    if (answers.financial === ConfirmationAnswer.Yes) {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.FinancialDetail}`);
    } else if (shouldCheckDailyActivity(answers)) {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.DailyActivity}`);
    } else {
      navigate(`/${PATHS.Summary}`);
    }
  };

  return (
    <ConfirmationQuestion
      onChange={onChange}
      value={answers.financial}
      onContinue={onContinue}
      step={questionContent.financial.step}
      title={questionContent.financial.title}
      subTitle={questionContent.financial.subTitle}
      whyWeWantTexts={questionContent.financial.whyWeWantTextsCustomer}
    />
  );
};

export default Financial;
